export var Layout;
(function (Layout) {
    Layout[Layout["zIndex"] = 2023] = "zIndex";
})(Layout || (Layout = {}));
//# sourceMappingURL=layout.js.map